import React from 'react';
import { useHistory } from 'react-router-dom';

import appRoutes from '../../../../app-routes';

import { useDownloadSingleDocument } from '../../hooks';

import * as Styled from './styled';

import { Utils } from 'billon-ui';
const { Icon, Loader: LoaderModule } = Utils;
const { Loader } = LoaderModule;

export const PreviewDownloadButton = ({ record, isPreview = false }) => {
  const history = useHistory();

  const { mutate: downloadFile, isLoading } = useDownloadSingleDocument(
    record?.jobId || record?.documentBlockchainAddress,
    record.title,
    isPreview,
  );

  const handleDownloadFileClick = (e) => {
    e.stopPropagation();
    if (isPreview) {
      history.push(
        appRoutes.DOCUMENT_PREVIEW.replace(
          ':id',
          record?.jobId || record?.documentBlockchainAddress,
        ),
      );
    } else {
      downloadFile();
    }
  };

  if (isLoading) {
    return (
      <Styled.LoadingButton color="link" className="ignore-row-click">
        <Loader width={36} />
      </Styled.LoadingButton>
    );
  }

  return (
    <Styled.PrevButton
      color="link"
      className="ignore-row-click"
      onClick={handleDownloadFileClick}
    >
      <Icon billon={!isPreview} name={isPreview ? 'eye' : 'pdf'} />
    </Styled.PrevButton>
  );
};
